import type { ReactNode } from 'react';

import Search from '@crehana/icons/Search';
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { colors, Loader } from '@crehana/ui';
import type { NamedProps } from 'react-select';
import { AsyncPaginate, type LoadOptions } from 'react-select-async-paginate';

import {
  darkMode,
  lightMode,
  WrapperMessages,
} from './SearchPaginateInput.styles';

const { grayLight } = colors;

interface SearchPaginateInputProps extends Partial<Pick<NamedProps, 'styles'>> {
  closeMenuOnSelect?: boolean;
  controlShouldRenderValue?: boolean;
  defaultValue?: unknown;
  disable?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  formatOptionLabel: (option: any, labelMeta: any) => ReactNode;
  hideSelectedOptions?: boolean;
  id: string;
  isClearable?: boolean;
  isDark?: boolean;
  isMulti?: boolean;
  isSearchable?: boolean;
  loadOptions: LoadOptions<unknown, unknown>;
  noResultsLabel?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChange: (value: any) => void;
  placeholder?: string;
  value: unknown;
}

const SearchPaginateInput: React.FC<SearchPaginateInputProps> = ({
  closeMenuOnSelect = true,
  controlShouldRenderValue = true,
  defaultValue,
  disable,
  formatOptionLabel,
  hideSelectedOptions = true,
  id,
  isClearable = true,
  isDark,
  isMulti,
  isSearchable,
  loadOptions,
  noResultsLabel,
  onChange,
  placeholder,
  styles,
  value,
}) => {
  const NoOptionsMessage = () => (
    <WrapperMessages isDark={isDark}>
      <Search color={grayLight} size={48} className="mb-16" />
      <p className="font-subtitle3 text-center mb-4">{noResultsLabel}</p>
    </WrapperMessages>
  );

  const LoadingMessage = () => (
    <WrapperMessages isDark={isDark}>
      <Loader isWhite={isDark} />
    </WrapperMessages>
  );

  return (
    <AsyncPaginate
      className="w-full z-2"
      isMulti={isMulti}
      isSearchable={isSearchable}
      instanceId={id || new Date().toString()}
      isDisabled={disable}
      value={value}
      defaultValue={defaultValue}
      isClearable={isClearable}
      closeMenuOnSelect={closeMenuOnSelect}
      hideSelectedOptions={hideSelectedOptions}
      controlShouldRenderValue={controlShouldRenderValue}
      debounceTimeout={300}
      loadOptions={loadOptions}
      formatOptionLabel={formatOptionLabel}
      components={{ NoOptionsMessage, LoadingMessage }}
      onChange={onChange}
      placeholder={placeholder}
      // Do not remove this IGNORE, coliverav is having troubles with his IDE
      // @ts-ignore
      styles={{ ...(isDark ? darkMode : lightMode), ...styles }}
      additional={{ page: 1 }}
    />
  );
};

export default SearchPaginateInput;
